"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
const LogoWrapper = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "LogoWrapper",
  class: "pl-l15cd5r5"
});
const Logo = ({
  logoAlt
}) => {
  return /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    alt: logoAlt,
    src: 'https://img1.wsimg.com/cdn/Image/All/All/1/All/8063f908-30d7-4c5a-a95f-67f769c8fc57/GD-Payments-Logo-L.svg'
  });
};
Logo.propTypes = {
  logoAlt: _propTypes.default.string
};
var _default = exports.default = Logo;